export default [
  {
    code: "kz",
  },
  {
    code: "mn",
  },
  {
    code: "kg",
  },
  {
    code: "ru",
  },
];
